import styled from "styled-components";
export const IconWrapper = styled.div `
  margin-left: auto;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const CustomOption = styled.li `
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: end;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  height: auto;
  box-sizing: border-box;
  font-size: ${({ theme }) => theme.fontTokens.font12[0]};
  line-height: ${({ theme }) => theme.fontTokens.font12[1]};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ disabled, theme, isActive }) => {
    if (disabled)
        return `rgba(${theme.colors.transparentBlack},0.16);`;
    if (isActive)
        return theme.colors.primaryLight;
    return theme.colors.black;
}};

  ${({ isActive }) => isActive
    ? `padding: 0.625rem 0 0.625rem 0`
    : `padding: 0.625rem 0 0.625rem 2.5rem`};

  & > span {
    width: 100%;
  }
  & > div {
    height: 1.25rem;
    min-width: 2.5rem;
  }
  & > div > span > svg {
    ${({ theme }) => `fill: ${theme.colors.primaryLight};`}
  }

  &:hover {
    cursor: pointer;
    ${({ theme, isHovered, disabled }) => !disabled && isHovered
    ? `background-color: rgba(${theme.colors.transparentBlack},0.06);`
    : ""}
  }
  ${({ theme, isHovered, disabled }) => !disabled && isHovered
    ? `background-color: rgba(${theme.colors.transparentBlack},0.06);`
    : ""}

  &:active {
    ${({ theme, disabled }) => !disabled
    ? `border: 1px solid ${theme.colors.grey15}; background-color: ${theme.colors.grey15}; color: ${theme.colors.white};`
    : ""};
    & > div > span > svg {
      ${({ theme }) => `fill: ${theme.colors.white};`}
    }
  }
`;
